function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.7625 23.075C10.3375 27.3125 4.6875 27.3125 4.6875 27.3125C4.6875 27.3125 4.6875 21.6625 8.925 20.2375",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24.4875 13.175L16 21.6625L10.3375 16L18.825 7.5125C22.0375 4.3 25.25 4.3375 26.625 4.5375C26.8372 4.56581 27.0341 4.66315 27.1855 4.81451C27.3368 4.96587 27.4342 5.16283 27.4625 5.375C27.6625 6.75 27.7 9.9625 24.4875 13.175Z",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M23.075 14.5875V22.6625C23.0712 22.9263 22.9634 23.1779 22.775 23.3625L18.7375 27.4125C18.6094 27.5404 18.449 27.6312 18.2733 27.6751C18.0977 27.719 17.9134 27.7144 17.7402 27.6618C17.567 27.6092 17.4113 27.5106 17.2897 27.3764C17.1682 27.2422 17.0853 27.0776 17.05 26.9L16 21.6625",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M17.4125 8.925H9.3375C9.07373 8.92876 8.82213 9.03659 8.6375 9.225L4.5875 13.2625C4.45955 13.3906 4.36878 13.551 4.32487 13.7267C4.28096 13.9023 4.28556 14.0866 4.33817 14.2598C4.39078 14.433 4.48943 14.5887 4.6236 14.7103C4.75778 14.8318 4.92243 14.9147 5.1 14.95L10.3375 16",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgRocketLaunch = function SvgRocketLaunch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRocketLaunch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/RocketLaunch.1bff2b59.svg";
export { ForwardRef as ReactComponent };